const BASE_URL = "https://api.dijlashipping.com/api";
// const BASE_URL = "http://localhost:5000/api";

export default BASE_URL;
